import { HTTP_TOKEN_REPORT } from "./http";

export const getLogs = (params) => {
  return HTTP_TOKEN_REPORT.get("webhook-log", { params }).then((result) => {
    return result.data;
  });
};
